import { render, staticRenderFns } from "./upload-new-file-button.component.vue?vue&type=template&id=8fc97c3a&scoped=true&"
import script from "./upload-new-file-button.component.ts?vue&type=script&lang=ts&"
export * from "./upload-new-file-button.component.ts?vue&type=script&lang=ts&"
import style0 from "./upload-new-file-button.component.scss?vue&type=style&index=0&id=8fc97c3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc97c3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
